import { API } from './resources'

export default {
  su: (lookup) => {
    return API.post('/admin/users/su', { lookup })
  },
  findUser: (lookup, platform) => {
    return API.post('/admin/users/find', { lookup, platform })
  },
  getUsersCount: (id) => {
    return API.get('/admin/users/count', { params: { id } })
  },
  getUserClients: (id) => {
    return API.get('/admin/users/clients', { params: { id } })
  },
  getUsersAndProjectForAnonymousComments: (limit, page) => {
    return API.get('/admin/comments/anonymous', { params: { limit, page } })
  },
  getProjectsCount: (id) => {
    return API.get('/admin/projects/count', { params: { id } })
  },
  getProjectsCountPerCategory: (id) => {
    return API.get('/admin/projects/count/category', { params: { id } })
  },
  getProjectsCountPerTag: (id) => {
    return API.get('/admin/projects/count/tag', { params: { id } })
  },
  getPrivateProjects: (limit, page) => {
    return API.get('/admin/projects/private', { params: { limit, page } })
  },
  getUncategorizedProjects: (limit, page, filter) => {
    return API.get('/admin/projects/uncategorized', { params: { limit, page, filter } })
  },
  getSignupSourcesCount: (startDate, endDate) => {
    return API.get('/admin/signups/count', { params: { startDate, endDate } })
  },
  getSignupSourcesCountryCount: (startDate, endDate, source) => {
    return API.get('/admin/users/signupSources/signupCountries', { params: { startDate, endDate, source } })
  },
  getLinkedInCount: () => {
    return API.get('/admin/linkedin/count')
  },
  getSurveySignupSourcesCount: (startDate, endDate) => {
    return API.get('/admin/survey/signups/count', { params: { startDate, endDate } })
  },
  getSurveySignupSourcesCountryCount: (startDate, endDate, source) => {
    return API.get('/admin/users/signupSources/surveyCountries', { params: { startDate, endDate, source } })
  },
  getSignupSources: (username) => {
    return API.get(`/admin/signups/${username}`)
  },
  getSurveySignupSources: (username) => {
    return API.get(`/admin/survey/signups/${username}`)
  },
  getUpdatedProfiles: (limit, page) => {
    return API.get('/admin/users/profiles', { params: { limit, page } })
  },
  getFakeUsers: (limit, page) => {
    return API.get('/admin/users/fake', { params: { limit, page } })
  },
  getUsers: (limit, page) => {
    return API.get('/admin/users', { params: { limit, page } })
  },
  getUserGrowthRate: (id, startDate, endDate) => {
    return API.get('/admin/users/growth', { params: { id, startDate, endDate } })
  },
  getAnalytics: (startDate, endDate) => {
    return API.get('/admin/users/analytics', { params: { startDate, endDate } })
  },
  getUsersFromLocation: (name, category, startDate, endDate) => {
    return API.get('/admin/users/analytics/location', { params: { name, category, startDate, endDate } })
  },
  getUsersFromCountrySource: (countryName, startDate, endDate, source) => {
    return API.get('/admin/users/signupSource/sourceLocation', { params: { countryName, startDate, endDate, source } })
  },
  getUsersFromCountrySurveySource: (countryName, startDate, endDate, source) => {
    return API.get('/admin/users/signupSource/surveyLocation', { params: { countryName, startDate, endDate, source } })
  },
  getMakeWeeklyAnalytics: (startDate, endDate) => {
    return API.get('admin/users/makeweekly', { params: { startDate, endDate } })
  },
  getUserTags: (username) => {
    return API.get(`/admin/${username}/profile/tags`)
  },
  getProjectsBetweenDates: (data) => {
    return API.post('/admin/projects/view', data)
  },
  getVirtualLobbies: () => {
    return API.get('/admin/getvirtuallobbies')
  },
  getProjectTemplates: () => {
    return API.get('/admin/gettemplates')
  },
  getProjectIdTemplates: (id) => {
    return API.get(`/admin/${id}/getidtemplates`, { params: { id } })
  },
  updateMaxWords: (data) => {
    return API.post('/admin/updatemaxwords', data)
  },
  updateMaxAttachments: (data) => {
    return API.post('/admin/updatemaxattachments', data)
  },
  replaceProjectOwner: (data) => {
    return API.put('/admin/projects/owner', data)
  },
  updateFeaturedProjectsCount: (data) => {
    return API.post('/admin/projects/featured/count', data)
  },
  updateProject: (id, data) => {
    return API.put(`/admin/projects/${id}`, data)
  },
  deleteUser: (username) => {
    return API.delete(`/admin/users/${username}`)
  },
  softDeleteUser: (username) => {
    return API.post(`/admin/users/softdelete/${username}`)
  },
  banUsers: (data) => {
    return API.post('/admin/users/ban', data)
  },
  revokeBan: (data) => {
    return API.delete('/admin/users/ban', { data: data })
  },
  getActivityBetween: ({ id, startDate, endDate, pageNo, filter, sort }) => {
    return API.get('/admin/users/activity', { params: { id, startDate, endDate, pageNo, filter, sort } })
  },
  downloadActivityBetween: ({ id, startDate, endDate, pageNo, filter, sort }) => {
    return API.get('/admin/users/activity/download', { params: { id, startDate, endDate, pageNo, filter, sort } })
  },
  getUserHistory: (data) => {
    return API.post('/admin/users/history', data)
  },
  sendBulkMessage: (data) => {
    return API.post('/admin/users/message', data)
  },
  getProjectSearchStats: (limit) => {
    return API.get('/admin/projects/search/stats', { params: { limit } })
  },
  getReferralStats: (startDate, endDate) => {
    return API.get('/admin/users/referrals', { params: { startDate, endDate } })
  },
  getUserReferrals: (username) => {
    return API.get(`/admin/users/referrals/${username}`)
  },
  getGroupConversations: (limit, offset) => {
    return API.get('/admin/conversations/group', { params: { limit, offset } })
  },
  getBadges: () => {
    return API.get('/admin/badges')
  },
  createBadge: (data) => {
    return API.post('/admin/badges', data)
  },
  updateProjectImageDate: (id) => {
    return API.put(`/admin/projects/${id}/image/update`)
  },
  updateUserAvatarDate: (username) => {
    return API.put(`/admin/users/${username}/avatar/update`)
  },
  movePostsToComments: (data) => {
    return API.post('/admin/projects/postsToComments', data)
  },
  createGroupConversation: (data) => {
    return API.post('/admin/conversations/group', data)
  },
  getProjectsForConversation: (id) => {
    return API.get(`/admin/conversation/${id}/projects`)
  },
  addProjectToConversation: (conversationID, projectID) => {
    return API.post(`/admin/conversation/${conversationID}/project/${projectID}`)
  },
  removeProjectFromConversation: (conversationID, projectID) => {
    return API.delete(`/admin/conversation/${conversationID}/project/${projectID}`)
  },
  reindex: (rebuild, type) => {
    if (type === 'User') {
      return API.post('/users/reindex', { addUser: true, deleteIndex: rebuild })
    }

    return API.post('/projects/reindex', { addProject: true, deleteIndex: rebuild })
  },
  reindexStatus: (type) => {
    const reindexType = type === 'User' ? 'users' : 'projects'

    return API.get(`/${reindexType}/reindexstatus`)
  },
  getEvents: () => {
    return API.get('/partners/events/all')
  },
  getPartners: () => {
    return API.get('/partners/all')
  },
  getResources: (filter) => {
    return API.get('admin/resources', { params: { filter } })
  },
  createResource: (data) => {
    return API.post('admin/resource', data)
  },
  saveResource: (resourceID, projectID, data) => {
    return API.put(`admin/resources/${resourceID}/project/${projectID}`, data)
  },
  getQuestions: () => {
    return API.get('admin/resources/questions')
  },
  createQuestion: (data) => {
    return API.post('admin/resources/question', data)
  },
  getCustomers: (filter) => {
    return API.get('admin/resources/customers', { params: { filter } })
  },
  createCustomer: (name) => {
    return API.post('admin/resources/customer', { name })
  },
  getCampaigns: (filter) => {
    return API.get('admin/resources/campaigns', { params: { filter } })
  },
  createCampaign: (name) => {
    return API.post('admin/resources/campaign', { name })
  },
  getResourceTypes: () => {
    return API.get('admin/resources/types')
  }
}
